import type { QuizHelperRequest } from "@/types/quizHelpers";

export function buildQuizHelperUserMessage(req: QuizHelperRequest): string {
  switch (req.type) {
    case "hint":
      return `Give me a hint for this quiz question (don't reveal the answer):\n\n"${req.questionPrompt}"`;
    case "walkthrough":
      return `Walk me through how to solve this quiz question step-by-step:\n\n"${req.questionPrompt}"`;
    case "simplify":
      return `Explain this quiz question in simple terms:\n\n"${req.questionPrompt}"`;
  }
}
